import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import ArticleBadge from "./ArticleBadge";

import { DIFFICULTY_LEVELS } from "../../utils";

const ArticleCardBody = ({
  classNames,
  cardInfoClassNames,
  title,
  excerpt,
  date,
  level,
  categories,
  isTextTruncated = true,
}) => {
  const Categories = ({ categories }) => {
    return (
      <div className="card-body__categories mb-3">
        {[...categories].map((cat, i) => (
          <ArticleBadge
            key={`article-cat-${i}`}
            label={cat.replace(/-/g, " ")}
            type="category"
          />
        ))}
      </div>
    );
  };

  return (
    <div className={cx("article-card-body d-flex flex-column", classNames)}>
      {(date || level) && (
        <div
          className={cx(
            "card-body__info d-flex flex-wrap justify-content-between mb-3",
            cardInfoClassNames
          )}
        >
          {date && (
            <p
              className="date card-text align-self-center mb-2 mr-md-4"
              dangerouslySetInnerHTML={{ __html: date }}
            />
          )}
          {level && <ArticleBadge label={level} type="level" />}
        </div>
      )}
      <p
        className="card-body__title card-text mb-3"
        dangerouslySetInnerHTML={{
          __html: title,
        }}
      />

      {categories && <Categories categories={categories} />}

      <div
        className={cx("card-body__excerpt card-text", {
          "custom-text-truncate": isTextTruncated,
        })}
        dangerouslySetInnerHTML={{ __html: excerpt }}
      />
    </div>
  );
};

ArticleCardBody.propTypes = {
  classNames: PropTypes.string,
  title: PropTypes.string,
  excerpt: PropTypes.string,
  date: PropTypes.string,
  level: PropTypes.oneOf(DIFFICULTY_LEVELS),
  categories: PropTypes.object,
};

export default ArticleCardBody;
